export function documentAnnotateHref(file: { name: string; url: string }) {
  const params = new URLSearchParams({ url: file.url, name: file.name });
  return `/documentAnnotate?${params.toString()}`;
}
